import { RouteObject } from "react-router";
import { VbsBaseDataRoute } from "@/routes/base-data/processes/vbs/vbs-base-data-route";
import { RltBaseDataRoute } from "@/routes/base-data/processes/rlt/rlt-base-data-route";
import { QpmBaseDataRoute } from "@/routes/base-data/processes/qpm/qpm-base-data-route";
import { vbsBaseDataRoutes } from "@/routes/base-data/processes/vbs/vbs-base-data-routes";
import { rltBaseDataRoutes } from "@/routes/base-data/processes/rlt/rlt-base-data-routes";
import { HtzBaseDataRoute } from "@/routes/base-data/processes/htz/htz-base-data-route";
import { htzBaseDataRoutes } from "@/routes/base-data/processes/htz/htz-base-data-routes";
import { qpmBaseDataRoutes } from "@/routes/base-data/processes/qpm/qpm-base-data-routes";
import { GfsBaseDataRoute } from "@/routes/base-data/processes/gfs/gfs-base-data-route";
import { gfsBaseDataRoutes } from "@/routes/base-data/processes/gfs/gfs-base-data-routes";

export const processesBaseDataRoutes: RouteObject[] = [
  {
    path: "gfs",
    element: <GfsBaseDataRoute />,
    children: gfsBaseDataRoutes,
  },
  {
    path: "htz",
    element: <HtzBaseDataRoute />,
    children: htzBaseDataRoutes,
  },
  {
    path: "qpm",
    element: <QpmBaseDataRoute />,
    children: qpmBaseDataRoutes,
  },
  {
    path: "rlt",
    element: <RltBaseDataRoute />,
    children: rltBaseDataRoutes,
  },
  {
    path: "vbs",
    element: <VbsBaseDataRoute />,
    children: vbsBaseDataRoutes,
  },
];
